import { createRouter, createWebHistory } from 'vue-router'

import { authenticationGuard, localizationGuard, userProfileGuard } from '@/utils/router'
import BookingView from '@/views/Booking'
import BookingDetailsView from '@/views/BookingDetails'
import BookingListView from '@/views/BookingList'
import Login from '@/views/Login'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'booking-list',
      component: BookingListView,
      meta: {
        requiresAuth: true,
        title: 'Booking List | ARM'
      }
    },
    {
      path: '/booking-details/:id',
      name: 'booking-details',
      component: BookingDetailsView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/booking',
      name: 'booking',
      component: BookingView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        redirectMember: true,
        title: 'Login | ARM'
      }
    },
    {
      path: '/registration',
      name: 'registration',
      component: async () => await import('@/views/Registration'),
      meta: {
        redirectMember: true,
        title: 'Registration | ARM'
      }
    },
    {
      path: '/registration-complete',
      name: 'registration-complete',
      component: async () => await import('@/views/RegistrationComplete'),
      meta: {
        redirectMember: true,
        title: 'Registration Complete | ARM'
      }
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: async () => await import('@/views/ResetPassword'),
      meta: {
        redirectMember: true,
        title: 'Login | ARM'
      }
    },
    {
      path: '/sent-reset-password-complete',
      name: 'sent-reset-password-complete',
      component: async () => await import('@/views/SentResetPasswordComplete'),
      meta: {
        redirectMember: true,
        title: 'Sent Reset Password Complete | ARM'
      }
    },
    {
      path: '/change-password/:token',
      name: 'change-password',
      component: async () => await import('@/views/ChangePassword'),
      meta: {
        redirectMember: true,
        title: 'Change Password | ARM'
      }
    },
    {
      path: '/change-password-complete',
      name: 'change-password-complete',
      component: async () => await import('@/views/ChangePasswordComplete'),
      meta: {
        redirectMember: true,
        title: 'Change Password Complete | ARM'
      }
    },
    {
      path: '/change-password-link-expired',
      name: 'change-password-link-expired',
      component: async () => await import('@/views/ChangePasswordLinkExpired'),
      meta: {
        redirectMember: true,
        title: 'Change Password Link Expired | ARM'
      }
    },
    {
      path: '/my-account',
      name: 'my-account',
      component: async () => await import('@/views/MyAccount'),
      meta: {
        requiresAuth: true,
        title: 'My Account | ARM'
      }
    },
    {
      path: '/email-ui-kit',
      name: 'email-ui-kit',
      component: async () => await import('@/views/EmailUIKit')
    },
    {
      path: '/ui-kit',
      name: 'ui-kit',
      component: async () => await import('@/views/UIKit')
    },
    {
      path: '/privacy-center',
      name: 'privacy-center',
      component: async () => await import('@/views/PrivacyCenter')
    }
  ],
  scrollBehavior () {
    document.getElementById('app')?.scrollIntoView({ block: 'start' })
  }
})

router.beforeEach(authenticationGuard)
router.beforeEach(userProfileGuard)
router.beforeEach(localizationGuard)

export default router
